import React from "react";
import {
	AssemblyIcon,
	SenateIcon,
} from "@logora/parliament.icons.regular_icons";
import styles from "./GroupLabel.module.scss";

interface GroupLabelProps {
	/** Group name displayed as label */
	groupName: string;
	/** Chamber name */
	chamber?: string | undefined;
	/** Label color. Must be an hex code */
	color?: string;
	/** Custom label class name */
	className?: string;
	/** Size variant */
	size?: "small" | "medium" | "large";
}

export const GroupLabel = ({
	groupName,
	chamber,
	color = "#434343",
	className = "",
	size = "medium",
}: GroupLabelProps) => {
	const hexToRgba = (hex: string, opacity: number) => {
		if (!hex) return "";
		const trimmedHex = hex.replace("#", "");
		const bigint = Number.parseInt(trimmedHex, 16);
		const r = (bigint >> 16) & 255;
		const g = (bigint >> 8) & 255;
		const b = bigint & 255;

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	};
	const lowerCaseChamber = chamber?.toLowerCase();

	return (
		<div
			className={`${styles.label} ${className} ${styles[size]}`}
			style={{
				backgroundColor: hexToRgba(color, 0.1),
				borderColor: hexToRgba(color, 0.15),
				color: color,
			}}
		>
			{chamber ? (
				<>
					{(lowerCaseChamber === "assemblee" || lowerCaseChamber === "an") && (
						<>
							<AssemblyIcon
								style={{
									fill: color,
								}}
								height={18}
								width={18}
							/>
							<div>AN</div>
						</>
					)}
					{(lowerCaseChamber === "senat" || lowerCaseChamber === "sn") && (
						<>
							<SenateIcon
								style={{
									fill: color,
								}}
								height={18}
								width={18}
							/>
							<div>SN</div>
						</>
					)}
					<div>|</div>
				</>
			) : (
				<div className={styles.dot} style={{ backgroundColor: color }} />
			)}
			<div>{groupName}</div>
		</div>
	);
};
